import { CubeSideName } from "../../components/Сube/types";
import { GenericObject } from "@/types";

export type GroupedEntries = GenericObject<GenericObject<number>>;

export type StatisticItem = {
  title: string;
  id: string;
  choices: {
    id: string;
    replyIndex: number;
    title: string;
    count: number;
    percentage: number;
  }[];
  average: number;
  totalChoicesSelected: number;
  totalReplies: number;
  type: string;
};

export interface IntersectionValue {
  side: CubeSideName;
  percentageValue: number;
}

export interface ReportQuestion {
  testSetId: string;
  text: string;
  dbColumn: string;
  entries: {
    [key: string]: number;
  };
  questionEntries: number[];
  average: number | null;
}

export interface ReportSection {
  choices: {
    key: string;
    name: string;
  }[];
  questions: ReportQuestion[];
}

export interface AggregatedReport {
  averageScore: ReportSection;
  implementationQuality: ReportSection;
  importance: ReportSection;
  otherScore: StatisticItem[];
}

export interface ValuesPerSide {
  totalCount: number;
  averagePercentageScore: number;
  benchmarkPercentageScore: number;
  implementationQualityPercentage: number;
  importancePercentage: number;
  aggregatedReport: AggregatedReport | null;
  consentItems: number[];
  qualityItems: number[];
  importanceItems: number[];
}

export enum Category {
  Consent = "C",
  Importance = "I",
  Quality = "Q",
}
